<template>
  <BaseDialog type="basic" :is-open="isOpen" title="Testimonials" @close="emits('close')">
    <ul v-if="spontaneousFeedbacks.length > 0" class="flex flex-col gap-1">
      <li
        v-for="spontaneousFeedback in spontaneousFeedbacks"
        :key="spontaneousFeedback.id"
        class="first:*:rounded-t-large! last:*:rounded-b-large!"
      >
        <SelectableTextFeedback
          :member="spontaneousFeedback.sender"
          :date="spontaneousFeedback.date"
          :text="spontaneousFeedback.text"
          :is-selected="isSpontaneousFeedbackSelected(spontaneousFeedback.id)"
          @click="toggleSpontaneousFeedback(spontaneousFeedback.id)"
        />
      </li>
    </ul>
    <div v-else class="mb-4 flex flex-col items-center justify-center">
      <EmptyQuestions hight-contrast />
      <h4 class="text-title-large text-on-surface text-center">Keine Daten verfügbar</h4>
      <p class="text-body-medium text-on-surface-variant max-w-md text-center">
        Es liegen aktuell keine passenden Daten vor. Du hast keine spontanen Feedbacks erhalten.
      </p>
    </div>
    <template #dismiss
      ><BaseTextButton @click="emits('close')">{{ $t('common.cancel') }}</BaseTextButton></template
    >
    <template #confirm
      ><BaseTextButton @click="selectSpontaneousFeedbacks">Auswählen</BaseTextButton></template
    >
  </BaseDialog>
</template>
<script lang="ts" setup>
  import { ref, watch } from 'vue'
  import BaseDialog from '../../../core/components/base/dialog/BaseDialog.vue'
  import BaseTextButton from '../../../core/components/base/button/text-button/BaseTextButton.vue'
  import type { Member } from '../../../core/models/member/member'
  import type { JSONContent } from '@tiptap/vue-3'
  import SelectableTextFeedback from './SelectableTextFeedback.vue'
import EmptyQuestions from '@/core/components/analytics/question-list/EmptyQuestions.vue'

  interface Props {
    isOpen: boolean
    spontaneousFeedbacks: ReadonlyArray<{
      id: string
      sender?: Member
      text: JSONContent
      date: string
    }>
    initialSpontaneousFeedbackIds: string[]
  }
  const props = defineProps<Props>()

  const selectedSpontaneousFeedbackIds = ref(new Set(props.initialSpontaneousFeedbackIds))

  watch(
    () => props.initialSpontaneousFeedbackIds,
    () => {
      selectedSpontaneousFeedbackIds.value.clear()
      for (const spontaneousFeedbackId of props.initialSpontaneousFeedbackIds) {
        selectedSpontaneousFeedbackIds.value.add(spontaneousFeedbackId)
      }
    },
  )

  const emits = defineEmits<{
    (e: 'close'): void
    (e: 'selectSpontaneousFeedbacks', spontaneousFeedbackIds: string[]): void
  }>()

  const isSpontaneousFeedbackSelected = (spontaneousFeedbackId: string) => {
    return selectedSpontaneousFeedbackIds.value.has(spontaneousFeedbackId)
  }
  const toggleSpontaneousFeedback = (spontaneousFeedbackId: string) => {
    if (selectedSpontaneousFeedbackIds.value.has(spontaneousFeedbackId)) {
      selectedSpontaneousFeedbackIds.value.delete(spontaneousFeedbackId)
    } else {
      selectedSpontaneousFeedbackIds.value.add(spontaneousFeedbackId)
    }
  }

  const selectSpontaneousFeedbacks = () => {
    emits('selectSpontaneousFeedbacks', [...selectedSpontaneousFeedbackIds.value])
    emits('close')
  }
</script>
